// @flow
import * as Sentry from '@sentry/react';
import * as React from 'react';

import Merchant from '../lib/Merchant';
import Layout from '../components/Layout';
import TextHeader1 from '../components/TextHeader1';
import TextParagraph from '../components/TextParagraph';
import TextStrong from '../components/TextStrong';
import ListItemMerchant from '../components/ListItemMerchant';
import Container from '../components/Container';
import ButtonBlock from '../components/ButtonBlock';
import type { TProps } from './types';
import { EVENT_TYPES } from '../HOCs/withEventManager';


function ExitConfirm(props: TProps): React.Node {
  const merchant: Merchant = props.navigation.current.state.merchant;
  const onExit = () => props.dispatchEvent(EVENT_TYPES.exit, {});

  return (
    <Layout {...props} showLogo padded>
      <Container mb={16} relative left={-24} width="100vw">
        <ListItemMerchant merchant={merchant} />
      </Container>

      <Container>
        <TextHeader1>
          <TextStrong extra>Are you sure you want to exit?</TextStrong>
        </TextHeader1>
        <TextParagraph>
          Your financial details will be securely removed for your security.
        </TextParagraph>

        <Container absolute bottom={24} left={24} width="calc(100% - 48px)">
          <ButtonBlock primary onClick={onExit}>
            Yes, exit
          </ButtonBlock>
          <Container mb={14} />
          <ButtonBlock secondary onClick={props.navigateBack}>
            No, continue
          </ButtonBlock>
        </Container>
      </Container>
    </Layout>
  );
}

// $FlowFixMe
export default Sentry.withProfiler(ExitConfirm, { name: 'ExitConfirm' });
